import { Components, Theme } from '@mui/material'

export const MuiLink: Components<Omit<Theme, 'components'>>['MuiLink'] = {
  defaultProps: {
    underline: 'hover',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.link,
      textDecorationColor: theme.palette.border.brand.strong,
    }),
  },
}
